import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

export type AuthEntryMode = 'login' | 'register-company';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class LoginComponent {
  private _mode: AuthEntryMode = 'login';
  name = '';
  username = '';
  email = '';
  password = '';
  error = '';
  loading = false;

  @Input()
  set mode(value: AuthEntryMode) {
    this._mode = value === 'register-company' ? 'register-company' : 'login';
  }

  get mode(): AuthEntryMode {
    return this._mode;
  }

  @Output() modeChange = new EventEmitter<AuthEntryMode>();

  constructor(private authService: AuthService) { }

  onSubmit() {
    this.loading = true;
    this.error = '';

    const request$ = this.mode === 'register-company'
      ? this.authService.registerCompany({
          name: this.name,
          username: this.username,
          email: this.email,
          password: this.password
        })
      : this.authService.login(this.username, this.password);

    request$.subscribe({
      next: () => {
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.error = this.mode === 'register-company'
          ? (err?.error?.message || 'Registrazione azienda non riuscita')
          : 'Credenziali non valide';
        console.error(err);
      }
    });
  }

  setMode(mode: AuthEntryMode) {
    this.mode = mode;
    this.error = '';
    this.loading = false;
    this.modeChange.emit(mode);
  }
}
